import type { FaireProductEntity } from "../../entity_types/product";

export const p_ev6grga8gh: FaireProductEntity = {
  token: "p_ev6grga8gh",
  type: "product",
  name: "Turmeric & Pepper Pasture-Raised Chicken Bone Broth 14oz",
  brandToken: "b_3nwax652hv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dece713be4b36a4f03712ab52f1698fbee8c7c5482590968cc1c36ea8d720788.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44f0014b93cbbc4a1774df6e239c5f3a4b7864a3f54f0f373a1303e6b87bfed1.png",
    "https://cdn.faire.com/fastly/3967b533a1a071f3d57aad6464a20cfa91b5853347194a575c999520d874ea96.png",
    "https://cdn.faire.com/fastly/7023edb7e4243c481ee1986f33b923c9cff868985e826dd5f23ea9748d1f2ac1.jpeg",
    "https://cdn.faire.com/fastly/8c27129a04c4349e8c30d1e35ebe981bd3c2ebb7564adaee5828edc09e64f9b8.png",
    "https://cdn.faire.com/fastly/81d70e70d5d6e4eaeb6bb5deecd27ad715ebbfd13a5bd20eea8776db829480b3.png",
  ],
  priceDollars: 8.31,
  description:
    'With it’s earthy-sweet taste, turmeric is the perfect anti-inflammatory addition to this bone broth tonic. We’ve paired it with freshly cracked pepper, fresh thyme and lemon to up the ante. Liquid Light is the epitome of good-tasting and good-for-you. It’s even safe for those on a low FODMAP diet, since it’s completely allium-free.\n\nA note on our sourcing: we only use we only use pasture-raised regenerative bones and organic herbs and veggies - no hormones, GMOs, added sugar, antibiotics or preservatives. From brew to jar, we also utilize a 100% plastic-free process, and all of our broths are shelf-stable!\n\nWe suggest drinking this flavor with MCT oil or grass-fed butter, or using it for any recipe that calls for oregano, cream, and garlic.\n\n"I suffer from an Autoimmune disease, and the Liquid Light turmeric flavor eased my joint flares overnight. I woke up in absolute amazement. FOND is nourishing AND delicious." -Gretchen R.\n',
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:34.480Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
